<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.data)">
        <span>{{ checkStatus(params.data) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: "CellRendererStatus",
    computed: {
        chipColor() {
            return value => {
                if (value.type === 1) {
                    return "success";
                } else {
                    return 'warning'
                }
            }
        },
        checkStatus() {
            return value => {
                if (value.type === 1) {
                    return 'Chính thức'
                } else {
                    return 'Tiềm năng'
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.ag-grid-cell-chip {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .2);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .2);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-warning {
        background: rgba(var(--vs-warning), .2);
        color: rgba(var(--vs-warning), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-pending {
        background: rgb(143, 143, 143, .2) !important;
        color: rgb(143, 143, 143) !important;
        font-weight: 500;
    }

    &.vs-chip-complete {
        background: rgba(157, 101, 201, .2) !important;
        color: rgb(157, 101, 201) !important;
        font-weight: 500;
    }
}
</style>
